import { shortDateTime, shortDay } from '../../shared/dateTime';

/**
 * Nieobecność kierowcy z kartoteki TMS (`constraint` z API,
 * `user-offers/driver-availability.ts`) — to fakt, nie szacunek.
 */
export const ABSENCE_CONSTRAINT = 'nieobecnosc';

/**
 * „Dostępny od” kierowcy, który nie jest dostępny teraz — jedno brzmienie
 * dla rekomendacji i listy kierowców (07.10.2026, arkusz „Problemy poza
 * brzmieniem”).
 *
 * Nieobecność z kartoteki TMS to fakt: bez „ok.”, sam dzień („nieobecny,
 * dostępny od 13.10”) — koniec nieobecności to początek dnia w Polsce,
 * więc godzina „00:00” nic by nie dodała. Termin z limitów czasu jazdy
 * (561/2006 bez ulg) to szacunek: z „ok.” i godziną.
 */
export function driverAvailableFromText(d: { availableFrom: string; constraint: string | null }): string {
  return d.constraint === ABSENCE_CONSTRAINT
    ? `nieobecny, dostępny od ${shortDay(d.availableFrom)}`
    : `dostępny od ok. ${shortDateTime(d.availableFrom)}`;
}
